import styled from 'styled-components'

export const PanelContainer = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 60px;
  right: ${props => (props.$isOpen ? '0' : '-400px')};
  width: 400px;
  height: calc(100vh - 60px);
  background: white;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  transition: right 0.3s ease-in-out;
  z-index: 100;
  display: flex;
  flex-direction: column;
`

export const PanelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #e2e8f0;
  background: #f7fafc;
`

export const PanelTitle = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a202c;
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #718096;
  padding: 0;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    background: #e2e8f0;
    color: #1a202c;
  }
`

export const PanelBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 1.5rem;
`

export const TabList = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 0;
`

export const Tab = styled.button<{ $active: boolean }>`
  background: none;
  border: none;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  color: ${props => (props.$active ? '#3182ce' : '#718096')};
  border-bottom: 2px solid
    ${props => (props.$active ? '#3182ce' : 'transparent')};
  margin-bottom: -1px;
  transition: all 0.2s;

  &:hover {
    color: #3182ce;
  }
`

export const TabContent = styled.div`
  animation: fadeIn 0.3s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const Section = styled.div`
  margin-bottom: 1.5rem;
`

export const SectionTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 1rem;
`

export const FormGroup = styled.div`
  margin-bottom: 1rem;
`

export const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #4a5568;
`

export const Input = styled.input`
  width: 100%;
  padding: 0.625rem 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.875rem;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: #3182ce;
    box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
  }

  &::placeholder {
    color: #a0aec0;
  }
`

export const PermissionCheckboxes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

export const PermissionLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
  color: #4a5568;

  input[type='checkbox'] {
    width: 1.125rem;
    height: 1.125rem;
    cursor: pointer;
  }

  span {
    user-select: none;
  }

  &:hover {
    color: #2d3748;
  }
`

export const Button = styled.button`
  width: 100%;
  background: #3182ce;
  color: white;
  border: none;
  padding: 0.625rem 1rem;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: #2c5282;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const ShareLinkContainer = styled.div`
  margin-top: 1rem;
`

export const ShareLinkBox = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
`

export const ShareLink = styled.div`
  flex: 1;
  padding: 0.625rem 0.75rem;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-family: monospace;
  font-size: 0.75rem;
  word-break: break-all;
  color: #4a5568;
`

export const CopyButton = styled.button`
  background: #4a5568;
  color: white;
  border: none;
  padding: 0.625rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;
  white-space: nowrap;

  &:hover {
    background: #2d3748;
  }
`

export const SharesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

export const ShareItem = styled.div`
  padding: 1rem;
  background: #f7fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s;

  &:hover {
    border-color: #cbd5e0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }
`

export const ShareItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
`

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const UserEmail = styled.div`
  font-weight: 500;
  color: #2d3748;
  font-size: 0.875rem;
`

export const SharedDate = styled.div`
  font-size: 0.75rem;
  color: #718096;
`

export const PermissionBadges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`

export const PermissionBadge = styled.span<{ $type: string }>`
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.625rem;
  background: ${props => {
    switch (props.$type) {
      case 'edit':
        return '#fef5e7'
      case 'comment':
        return '#e8f4fd'
      default:
        return '#edf2f7'
    }
  }};
  color: ${props => {
    switch (props.$type) {
      case 'edit':
        return '#d68910'
      case 'comment':
        return '#2874a6'
      default:
        return '#4a5568'
    }
  }};
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
`

export const RevokeButton = styled.button`
  background: none;
  color: #e53e3e;
  border: 1px solid #feb2b2;
  padding: 0.375rem 0.75rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.75rem;
  font-weight: 500;
  transition: all 0.2s;

  &:hover {
    background: #fed7d7;
    border-color: #fc8181;
  }
`

export const ErrorMessage = styled.div`
  padding: 0.75rem;
  background: #fed7d7;
  color: #c53030;
  border-radius: 6px;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  animation: slideDown 0.3s ease;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const SuccessMessage = styled.div`
  padding: 0.75rem;
  background: #c6f6d5;
  color: #22543d;
  border-radius: 6px;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  animation: slideDown 0.3s ease;
`

export const EmptyState = styled.div`
  text-align: center;
  padding: 2rem 1rem;
  color: #718096;

  p {
    margin: 0.5rem 0;
    font-size: 0.875rem;

    &:first-child {
      font-weight: 500;
      color: #4a5568;
    }
  }
`

export const Divider = styled.div`
  height: 1px;
  background: #e2e8f0;
  margin: 1.5rem 0;
`
